import indexOf from "lodash/indexOf";
import map from "lodash/map";

import { ROLL_FORWARD_WIZARD_STEP_ORDER, RollForwardWizardStep } from "../roll_forward_wizard.constants";
import { getFirstIncompleteStepIndex } from "../roll_forward_wizard.utils";
import { ROLL_FORWARD_WIZARD_STEPS } from "../roll_forward_wizard_steps";
import { useRollForwardWizardStore, useRollForwardWizardStoreActions } from "../roll_forward_wizard_store";

export const useRollForwardWizardNavigation = () => {
  const activeStep = useRollForwardWizardStore((state) => state.activeStep);
  const stepsCompleteness = useRollForwardWizardStore((state) =>
    map(ROLL_FORWARD_WIZARD_STEP_ORDER, (step) => ROLL_FORWARD_WIZARD_STEPS[step].isComplete(state))
  );
  const { setActiveStep } = useRollForwardWizardStoreActions().navigation;

  const activeStepIndex = indexOf(ROLL_FORWARD_WIZARD_STEP_ORDER, activeStep);
  const isFirstStep = activeStepIndex === 0;
  const isLastStep = activeStepIndex === ROLL_FORWARD_WIZARD_STEP_ORDER.length - 1;

  const firstIncompleteStepIndex = getFirstIncompleteStepIndex(stepsCompleteness);
  const isStepReachable = (index: number) => index <= firstIncompleteStepIndex;
  const canGoNext = isStepReachable(activeStepIndex + 1);

  const goNext = () => {
    if (canGoNext && !isLastStep) {
      setActiveStep(ROLL_FORWARD_WIZARD_STEP_ORDER[activeStepIndex + 1]);
    }
  };

  const goPrevious = () => {
    if (!isFirstStep) {
      setActiveStep(ROLL_FORWARD_WIZARD_STEP_ORDER[activeStepIndex - 1]);
    }
  };

  const goTo = (step: RollForwardWizardStep) => {
    if (isStepReachable(indexOf(ROLL_FORWARD_WIZARD_STEP_ORDER, step))) {
      setActiveStep(step);
    }
  };

  return { activeStep, isFirstStep, isLastStep, canGoNext, isStepReachable, goNext, goPrevious, goTo };
};
